import React, { useEffect, useState } from 'react';
import axios from 'axios';
import '../assets/css/HighlightsInsights.css';
import { LanguageContext } from '../contexts/LanguageContext'; // Import the LanguageContext
import { useContext } from 'react';

const HeroSection = ({ title, subtitle }) => (
  <header className="hero">
    <div className="hero-overlay">
      <h1>{title}</h1>
      <p>{subtitle}</p>
    </div>
  </header>
);

const HighlightsInsights = () => {
  const [articles, setArticles] = useState([]);
  const [selectedArticle, setSelectedArticle] = useState(null);

  useEffect(() => {
    axios.get('https://my-strapi-cms-5r1k.onrender.com/api/news-articles?populate=*')
      .then((res) => {
        setArticles(res.data.data);
        setSelectedArticle(res.data.data[0]); // Default to first article
      })
      .catch((err) => console.error('Error fetching articles:', err));
  }, []);

  return (
    <div className="insights-page">
      <aside className="article-menu">
        {/* <h2 className="menu-title">Articles</h2> */}
        <ul className="menu-list">
          {articles.map((article) => (
            <li
              key={article.id}
              className={`menu-item ${selectedArticle?.id === article.id ? 'active' : ''}`}
              onClick={() => setSelectedArticle(article)}
            >
              {article.Title}
            </li>
          ))}
        </ul>
      </aside>

      <main className="article-content">
        {selectedArticle && (
          <div className="article-details">
            <h1 className="article-title">{selectedArticle.Title}</h1>
            <p className="article-date">
              {new Date(selectedArticle.PublishedDateTime).toLocaleDateString()}
            </p>
            {selectedArticle.Image?.length > 0 && selectedArticle.Image[0]?.url && (
              <img
                src={`https://my-strapi-cms-5r1k.onrender.com${selectedArticle.Image[0].url}`}
                alt={selectedArticle.Title}
                className="article-image"
              />
            )}
            <div
              className="article-body"
              dangerouslySetInnerHTML={{ __html: selectedArticle.Content }}
            />
          </div>
        )}
      </main>
    </div>
  );
};

export default function () {
const { t } = useContext(LanguageContext); // Access translations
  return (
    <>
    <HeroSection
    title={t.highlights_page_title}
    subtitle=""
    />
    <HighlightsInsights />
    </>
  );
}
